import { Button } from "antd";
import React from "react";


const DoctorCalander = (props) => {
    return (
        <div style={{ width: '100%',textAlign:'center', height: 600 }}>
            <Button>DoctorCalander </Button>
            <p>Doctor Calander here</p>
        </div>
    )
}


export default DoctorCalander